module.exports = __webpack_public_path__ + "static/media/preview_profile.cc34631e.svg";